<template>
    <div class="stockProduct_single">

        <div class="vkfhikf">
            <div class="title">{{ $t('other.a3352') }}（{{ pageTotal }}{{ $t('other.a1326') }}）</div>

            <div class="weconkf">

                <div style="display:flex;align-items: center">
                    <el-checkbox class="menu" v-model="checked" @change="hanleCheckAll">{{ $t('other.a2520') }}({{
                        alltotal.length }})</el-checkbox>

                    <el-dropdown class="menu" size="mini" v-if="vipLevel == 0">
                        <el-button size="medium" type="primary">
                            {{ $t('other.a2521') }} <i class="el-icon-arrow-down el-icon--right"></i>
                        </el-button>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item @click.native="massDeletd()">{{ $t('other.a2523') }}</el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                    <el-dropdown class="menu" size="mini" v-if="vipLevel == 0">
                        <el-button size="medium" type="primary">
                            {{ $t('other.a3353') }} <i class="el-icon-arrow-down el-icon--right"></i>
                        </el-button>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item @click.native="goToInsertGoods()">{{ $t('other.a2526') }}</el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                    <el-button type="primary" @click="openIsUpload">{{ $t('other.a3375') }}</el-button>
                </div>

            </div>
        </div>
        <div v-if="!galleryDataList.length" class="nodata">{{ $t('other.a3354') }}</div>

        <div v-else class="overseaProduct_list">
            <div :class="{ 'overseaProduct_item': true, 'overseaProduct_item_active': activeIndex === index }"
                @mouseenter="activeIndex = index" @mouseleave="activeIndex = -1" v-for="(item, index) in galleryDataList"
                :key="index">
                <div class="lvinf">
                    <el-checkbox v-model="item.checked" @change="hanleCheckIds(item, index)"></el-checkbox>
                    <div></div>
                    <span class="createTime">{{ item.createTime ? setISOTime(item.createTime) : '-' }}</span>
                </div>
                <div class="ovjknfk" @click="viewMore(item)">
                    <div class="pic_box">
                        <img style="width:100%" :src="item.imagesUrl" />
                    </div>
                    <div class="title_overseaProduct">{{ item.layoutName }}</div>
                    <!-- <div class="item_desc_parentsku">{{$t('other.a249')}}{{item.itemSku}}</div>
                      <div  class="item_desc">{{item.storeItems.length}}{{$t('other.a2615')}}</div>
                      <div  class="item_desc">{{$t('other.a2614')}}：{{item.totalNum}}</div> -->
                </div>
                <!-- <div class="update_overseaProduct"><span :class="{'btn':true,'btn_reverse':item.agency}">{{item.agency ? '我已分销' : $t('other.a1742')}}</span></div> -->
                <!-- <div class="update_overseaProduct">
                    <span class="bitbn"></span>
                    <el-dropdown>
                        <el-button size="mini" type="primary">{{ $t('other.a3216') }}</el-button>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item @click.native="publish(item, 4)">发布TEMU产品</el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                </div> -->
            </div>
        </div>
        <div class="Pager">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                :current-page.sync="dataParams.pageNum" :page-sizes="[15, 20, 30, 100]" :page-size="dataParams.pageSize"
                layout="total, sizes, prev, pager, next, jumper" :total="pageTotal" :key="pagekey">
            </el-pagination>
        </div>
        <el-dialog :title="$t('other.a3376')" :visible.sync="isUpload" width="90%">
            <div class="stepsBox">
                <div class="stepsItem">
                    <div class="stepsIndex">
                        1
                    </div>
                    <div class="stepsTitle">
                        {{ $t('other.a3377') }}
                    </div>
                    <div class="stepsContent">
                        <!-- <a href="../../assets/TEMU批量上传模板.xlsx" target="downloadFile" download>点击 下载批量上架产品 到TEMU后台的模板</a>
                        <el-button type="text">
                            <a href="../../assets/TEMU批量上传模板.xlsx" target="downloadFile" download>点击 下载批量上架产品 到TEMU后台的模板</a></el-button> -->
                        <el-button type="text" @click="downUrl">{{ $t('other.a3378') }}</el-button>
                    </div>
                </div>
                <div class="stepsItem">
                    <div class="stepsIndex">
                        2
                    </div>
                    <div class="stepsTitle">
                        {{ $t('other.a3379') }}
                    </div>
                    <div class="stepsContent">
                        <div class="tips" v-html="$t('other.a3380')">
                        </div>
                        <el-upload class="upload-demo" ref="uploadTEMURef" action="#" :limit="1" :http-request="uploadTEMU"
                            :before-upload="beforeUpload" :on-remove="handleRemove">
                            <el-button slot="trigger" size="small" type="primary" style="margin-top: 20px;">{{ $t('other.a368') }}</el-button>
                            <el-button style="margin-left: 10px;background: #ff8000;border-color: #ff8000;" size="small"
                                type="success" @click.stop="submitUpload">{{ $t('other.a3385') }}</el-button>
                        </el-upload>
                        <div style="margin-top: 20px;">
                            <span class="tips">{{ $t('other.a3381') }}</span>{{ $t('other.a3382') }}<span
                                class="tips">{{ $t('other.a3383') }}</span>{{ $t('other.a3384') }}
                        </div>
                    </div>
                </div>
            </div>
            <div class="recordBox">
                <div class="recordTitle">
                    {{ $t('other.a3386') }}
                </div>
                <el-table :data="recordData" border style="width: 100%">
                    <el-table-column prop="fileName" :label="$t('other.a3387')">
                    </el-table-column>
                    <el-table-column prop="totalRecords" :label="$t('other.a3388')">
                    </el-table-column>
                    <el-table-column prop="taskStatus" :label="$t('other.a55')">
                        <template slot-scope="scope">
                            <div>
                                {{ scope.row.taskStatus == 0 ? $t('other.a3389') : scope.row.taskStatus == 1 ? $t('other.a3390') :
                                    scope.row.taskStatus ==
                                        2 ? $t('other.a3391') : scope.row.taskStatus == 3 ? $t('other.a1912') : $t('other.a3392')}}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="process" :label="$t('other.a3393')">
                        <template slot-scope="scope">
                            <div>
                                {{ scope.row.process }}%
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="successRecords" :label="$t('other.a3394')">
                    </el-table-column>
                    <el-table-column prop="failedMessage" :label="$t('other.a3395')">
                    </el-table-column>
                    <el-table-column prop="createdTime" :label="$t('other.a57')">
                        <template slot-scope="scope">
                            <div>
                                {{ formatISODateToFull(scope.row.createdTime) }}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="startTime" :label="$t('other.a3396')">
                        <template slot-scope="scope">
                            <div>
                                {{ formatISODateToFull(scope.row.startTime) }}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="endTime" :label="$t('other.a3397')">
                        <template slot-scope="scope">
                            <div>
                                {{ formatISODateToFull(scope.row.endTime) }}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column :label="$t('other.33')" align="center">
                        <template slot-scope="scope">
                            <el-button v-if="scope.row.taskStatus == 1" size="mini" type="warning"
                                @click="handleStop(scope.$index, scope.row)">{{$t('other.a3398')}}</el-button>
                            <el-button size="mini" type="danger"
                                @click="handleDelete(scope.$index, scope.row)">{{$t('other.a312')}}</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <div style="text-align:right">
                    <el-pagination @size-change="handleSizeRecordChange" @current-change="handleCurrentRecordChange"
                        :current-page="getRecordDataList.pageNum" :page-sizes="[15, 20, 30, 50]"
                        :page-size="getRecordDataList.pageSize" layout="total, sizes, prev, pager, next, jumper"
                        :total="getRecordDataList.total">
                    </el-pagination>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="isUpload = false">{{$t('other.a5')}}</el-button>
            </span>
        </el-dialog>

    </div>
</template>
  
<script>
import utils from '../../utils/utils'
import { showLoading, hideLoading } from '../../assets/js/loading.js'
import galleryApi from '../../api/moudles/gallery'
import { mapState, mapActions, mapMutations } from 'vuex'
export default {
    data() {
        return {
            isUpload: false,
            userId: JSON.parse(localStorage.getItem('userInfo')).userId,
            storeOptions: [],
            targetIndex: [],
            listErrorOptions: [],
            showErrorDeleteItem: false,
            storeId: null,
            token: {
                token: JSON.parse(localStorage.getItem('userInfo')).token
            },
            value: 3,
            currentPage: null,
            dataParams: {
                pageSize: 100,
                pageNum: 1,
                userId: JSON.parse(localStorage.getItem('userInfo')).userId
            },
            pageTotal: 0,
            galleryDataList: [],
            checkIds: [],
            checkIdsArr: [],
            checked: false,
            activeIndex: -1,
            vipLevel: JSON.parse(localStorage.getItem('userInfo')).vipLevel,
            showProduct: false,
            showshopOption: false,
            input10: null,
            openQueHuochuankao: false,
            storeData: {},
            outOfstockReminderAmont: 0,
            outOfstockReminder: [],
            remindData: [],
            sluginreminder: false,
            unsalable: [],
            unsalableData: {},
            transproductDia: false,
            targetStoreid: null,
            getRecordDataList: {
                pageSize: 20,
                pageNum: 1,
                total: 0
            },
            pagekey: 0,
            fileData: null,
            recordData: [],
            exportStatus:true,
        }
    },

    components: {
    },
    computed: {
        ...mapState({
            mygoodslist: state => state.mygoods.mygoodslist,
            //   userId: state => state.shopaccess.userInfo.userId,
            userStormList: state => state.userStoreItems.userStormList,
            itemsCount: state => state.userStoreItems.itemsCount,
            deleTip: state => state.userStoreItems.deleTip,
            deletSuccess: state => state.userStoreItems.deletSuccess,
            getDateSuccess: state => state.userStoreItems.getDateSuccess,
            xuehuoInfo: state => state.userStoreItems.xuehuoInfo,
            xuehuoInfocount: state => state.userStoreItems.xuehuoInfocount,
            secondPassword: state => state.shopaccess.secondPassword,
            newUserstoreItem: state => state.userStoreItems.newUserstoreItem,
            refresh: state => state.userStoreItems.refresh,
            slugInReminder: state => state.userStoreItems.slugInReminder,
            //   unsalable:state => state.userStoreItems.unsalable,

        }),
        alltotal() {
            this.targetIndex = []
            let list = this.galleryDataList.filter((p, index) => {
                if (p.checked) {
                    this.targetIndex.push(p.id)
                    return p
                }
            })
            if (list.length == this.galleryDataList.length) {
                this.checked = true
            } else {
                this.checked = false
            }
            return list ? list : []
        },
        num() {
            let num = 0
            if (this.galleryDataList) {
                num = this.galleryDataList.length
            }
            return num
        },
    },
    watch: {
    },
    created() {

        if (!localStorage.getItem('setPage')) {
            localStorage.setItem('setPageSize', 100)
            localStorage.setItem('setPageIndex', 1)
        }
        this.init()
    },
    methods: {

        ...mapActions('userStoreItems', [
            'getStockRemind',
        ]),
        ...mapMutations('userStoreItems', [
            'TARGET_ALL',
            'GET_DATA_STATUS_COLSE',
            'KEEP_CHOOSED_ITEM',
            'SET_REPLENISHMENT_PREIOD',
            'GET_UNSALABLE_DATA'
        ]),
        downUrl() {
            let url = '/TEMU批量上传模板.xlsx'; // public 目录下的文件的 URL
            let link = document.createElement('a'); // 创建一个 <a> 元素
            link.href = url; // 设置链接的 href 属性为文件的 URL
            link.download = 'TEMU批量上传模板.xlsx'; // 设置下载的文件名
            link.style.display = 'none'; // 隐藏链接
            document.body.appendChild(link); // 将链接添加到文档中
            link.click(); // 模拟点击链接以触发下载
            document.body.removeChild(link); // 下载完成后移除链接
        },
        openIsUpload() {
            this.isUpload = true
            this.getRecordDataList.pageNum = 1
            this.getRecordDataList.pageSize = 20
            this.getRecordData()
            if (this.fileData) {
                this.$nextTick(() => {
                    this.$refs.uploadTEMURef.clearFiles()
                    this.fileData = null
                })
            }
        },
        beforeUpload(file) {
            console.log(file)
            let extension = file.name.substring(file.name.lastIndexOf('.') + 1);
            const isxlsx = extension === 'xlsx';

            if (!isxlsx) {
                this.$message.error(this.$t('other.a3409'));
            }
            return isxlsx;
        },
        uploadTEMU(e) {
            console.log(e)
            console.log("===-===")
            this.fileData = e.file
        },
        handleRemove(file, fileList) {
            console.log(file, fileList);
            this.fileData = null
        },
        submitUpload() {
            if (!this.fileData || !this.exportStatus) {
                return
            }
            this.exportStatus = false;
            // return
            const loading = this.$loading({
                lock: true,
                text: this.$t('other.a3410'),
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            var formData = new FormData()
            formData.append('goodsFile', this.fileData)
            formData.append('userId', this.userId)
            galleryApi
                .batchAddGoods(formData)
                .then(res => {
                    loading.close();
                    console.log(res)
                        this.exportStatus = true;
                    if (res.code === 200) {
                        this.$message.success(res.data)
                        console.log("===1===")
                        this.getRecordDataList.pageNum = 1
                        this.getRecordDataList.pageSize = 20
                        this.getRecordData()
                        this.$refs.uploadTEMURef.clearFiles()
                        this.fileData = null
                    } else {
                        this.$message.error(res.msg)
                    }
                }).catch(err => {
                    loading.close();
                        this.exportStatus = true;
                })
        },
        getRecordData() {
            galleryApi
                .getProgress(this.userId, this.getRecordDataList.pageNum, this.getRecordDataList.pageSize)
                .then(res => {
                    if (res.code === 200) {
                        console.log("===1===")
                        this.recordData = res.data.records
                        this.getRecordDataList.total = res.data.total
                    } else {
                        this.$message.error(res.msg)
                    }
                })
        },
        handleSizeRecordChange(val) {
            console.log(`每页 ${val} 条`);
            localStorage.setItem('setPageSize', val)
            this.getRecordDataList.pageNum = 1
            this.getRecordDataList.pageSize = parseInt(`${val}`)
            this.getRecordData()
        },
        handleCurrentRecordChange(val) {
            this.getRecordDataList.pageNum = parseInt(`${val}`)
            this.getRecordData()
        },
        formatISODateToFull(isoString) {
            if (!isoString) {
                return
            }
            const date = new Date(isoString);

            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const day = String(date.getDate()).padStart(2, '0');

            const hours = String(date.getHours()).padStart(2, '0');
            const minutes = String(date.getMinutes()).padStart(2, '0');
            const seconds = String(date.getSeconds()).padStart(2, '0');

            return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
        },
        handleStop(index, item) {
            this.$confirm(this.$t('other.a3411'), this.$t("other.a142"), {
                confirmButtonText: this.$t('other.a145'),
                cancelButtonText: this.$t('other.a146'),
                type: 'warning'
            }).then(() => {
                galleryApi
                    .stopOrDeleteTask(this.userId, 1, item.id)
                    .then(res => {
                        if (res.code === 200) {
                            this.$message.success(res.data)
                            this.getRecordDataList.pageNum = 1
                            this.getRecordDataList.pageSize = 20
                            this.getRecordData()
                        } else {
                            this.$message.error(res.msg)
                        }
                    })
            })
        },
        handleDelete(index, item) {
            let text = ''
            if (item.taskStatus == 1) {
                text = this.$t('other.a3412')
            } else if (item.taskStatus == 2) {
                text = this.$t('other.a3413')
            } else {
                text = this.$t('other.a3414')
            }
            this.$confirm(text, this.$t("other.a142"), {
                confirmButtonText: this.$t('other.a145'),
                cancelButtonText: this.$t('other.a146'),
                type: 'warning'
            }).then(() => {
                galleryApi
                    .stopOrDeleteTask(this.userId, 0, item.id)
                    .then(res => {
                        if (res.code === 200) {
                            this.getRecordDataList.pageNum = 1
                            this.getRecordDataList.pageSize = 20
                            this.getRecordData()
                            this.$message.success(res.msg)
                        } else {
                            this.$message.error(res.msg)
                        }
                    })
            })
        },
        format(dataString) {
            //dataString是整数，否则要parseInt转换
            var time = new Date(dataString);
            var year = time.getFullYear();
            var month = time.getMonth() + 1;
            var day = time.getDate();
            var hour = time.getHours();
            var minute = time.getMinutes();
            var second = time.getSeconds();
            return year + '-' + (month < 10 ? '0' + month : month) + '-' + (day < 10 ? '0' + day : day) + ' ' + (hour < 10 ? '0' + hour : hour) + ':' + (minute < 10 ? '0' + minute : minute) + ':' + (second < 10 ? '0' + second : second)
        },
        publish(item, num) {
            console.log(item);
            let router;
            router = this.$router.resolve({
                name: "publishTEMU",
                query: {
                    id: item.id,
                    from: "/hasAgent"
                }
            });
            window.open(router.href, "_blank");
        },
        setISOTime(time) {
            time = time.replace(/-/, '-')
            time = time.replace(/-/, '-')
            time = time.replace(/T/, ' ')
            let times = time.split('.')
            return times[0]
        },
        massDeletd() {
            let arr = []
            let num = 0
            console.log(this.alltotal)
            this.alltotal.forEach(i => {
                arr.push(i.id)
            })



            console.log(arr)

            let desc = this.$t('other.a2587') + arr.length + this.$t('other.a2588')
            this.$confirm(desc, this.$t("other.a142"), {
                confirmButtonText: this.$t('other.a145'),
                cancelButtonText: this.$t('other.a146'),
                type: 'warning'
            }).then(() => {
                this.listErrorOptions = []
                var formData = new FormData()
                formData.append('patternInfoId', arr)
                galleryApi
                    .deletePattern(formData)
                    .then(res => {
                        console.log(res)
                        if (res.code === 200) {
                            this.$message.success(res.msg)
                            this.getOverseaData()
                        }
                    })

            })
        },
        hanleCheckAll() {
            if (this.checked) {
                this.galleryDataList.forEach(p => {
                    p.checked = true
                    if (this.checkIds.indexOf(p.id) != -1) {
                    } else {
                        this.checkIds.push(p.id)
                        this.checkIdsArr.push(p)
                    }
                })
            } else {
                this.galleryDataList.forEach(p => {
                    p.checked = false
                    console.log(p.id)
                    console.log(this.checkIds.indexOf(p.id))
                    if (this.checkIds.indexOf(p.id) != -1) {
                        this.checkIds.splice(this.checkIds.indexOf(p.id), 1)
                        this.checkIdsArr.splice(this.checkIds.indexOf(p.id), 1)
                    } else {
                        // this.checkIds.push(p.id)
                        // this.checkIdsArr.push(p)
                    }
                })
                console.log(this.checkIds)

            }
        },
        hanleCheckIds(item, index) {
            console.log(item)
            if (this.checkIds.indexOf(this.galleryDataList[index].id) != -1) {
                this.checkIds.splice(this.checkIds.indexOf(this.galleryDataList[index].id), 1)
                this.checkIdsArr.splice(this.checkIds.indexOf(this.galleryDataList[index].id), 1)
            } else {
                this.checkIds.push(this.galleryDataList[index].id)
                this.checkIdsArr.push(this.galleryDataList[index])
            }
            // item.checked = !item.checked
            console.log(this.galleryDataList)
        },

        viewMore(item) {
            console.log(item)
            this.$router.push({
                path: '/galleryDetails',
                query: {
                    from: JSON.stringify(this.$route.path),
                    patternInfoId: item.id,
                }
            })
        },

        goToInsertGoods() {
            this.$router.push({
                path: '/createGallery', query: {
                    from: JSON.stringify(this.$route.path),
                    addition: JSON.stringify(false),
                    components: JSON.stringify(true),

                }
            })
        },

        removeItem() {
            if (this.targetIndex) {
                this.targetIndex.forEach((p) => {
                    this.galleryDataList.forEach((i, index) => {
                        if (i.id == p) {
                            i.checked = false
                            this.galleryDataList.splice(index, 1)
                        }
                    })
                })
            }
        },
        cancelTarget() {
            this.galleryDataList.forEach(p => {
                p.checked = false
            })
        },

        init() {
            this.getOverseaData()
        },
        //获取海外仓的库存产品
        getOverseaData() {
            this.checked = false
            showLoading()
            galleryApi
                .getPatternPage(this.dataParams.pageNum, this.dataParams.pageSize, 0)
                .then(res => {
                    if (res.code === 200) {
                        console.log('数据1', res.data)
                        res.data.records.forEach(i => {
                            i.checked = false
                        })
                        this.galleryDataList = res.data.records
                        console.log(this.galleryDataList)
                        this.pageTotal = res.data.total
                        console.log(this.pageTotal)

                    } else {
                        this.$message.warning(res.msg)
                    }
                })
        },

        handleSizeChange(val) {
            console.log(`每页 ${val} 条`);
            localStorage.setItem('setPageSize', val)
            this.dataParams.pageNum = 1
            this.dataParams.pageSize = parseInt(`${val}`)
            this.getOverseaData()
        },
        //显示当前第几页
        handleCurrentChange(val) {
            this.dataParams.pageNum = parseInt(`${val}`)
            this.getOverseaData()
        },
    }
}

</script>
<style lang='scss' scoped>
/deep/ .el-dropdown-menu__item {
    font-size: 22px;
    line-height: 45px;
    padding: 2px 15px;
    border-bottom: 1px solid #eee;
}


.stockProduct_single {
    background: #eee;
    min-height: 100vh;
    position: relative;





    .ovjknfk {
        cursor: pointer;
    }


    .Pager {
        position: fixed;
        bottom: 0;
        left: 205px;
        right: 0;
        height: 40px;
        line-height: 40px;
        background-color: #fff;
        text-align: right;
    }

    .nodata {
        position: absolute;
        left: 0;
        right: 0;
        margin: auto;
        text-align: center;
        font-size: 20px;
        margin-top: 200px;
    }

    .lvinf {
        display: flex;
        justify-content: space-between;
        box-sizing: border-box;
        padding: 3px 8px
    }

    .createTime {
        font-size: 10px;
    }


    .title {
        font-size: 18px;
        font-weight: 400;
        ;
        margin-bottom: 20px;

    }

    .vkfhikf {
        background-color: #fff;
        // position: fixed;
        // right: 0;
        // left: 205px;
        // z-index: 79;
        // top: 50px;
    }

    .weconkf {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-top: 20px;
        padding-bottom: 10px;
        border-bottom: 1px solid #eee;

        .menu {
            margin-right: 10px;
            margin-left: 0px;
        }
    }

    .store_header {
        margin: 10px 0;
        background: #fff;
        padding-bottom: 7px;
        display: flex;

        .pomog {
            display: flex;
            flex-wrap: wrap;
            flex: 1;

        }


        .btn {
            border: 1px solid #d9d9d9;
            box-sizing: border-box;
            padding: 3px 2px;
            margin-right: 3px;
            margin-bottom: 5px;
            cursor: pointer;
            line-height: 20px;
            border-radius: 3px;
        }

        .active {
            color: #fff;
            background: #409eff;
        }
    }


    .overseaProduct_list {
        display: flex;
        flex-wrap: wrap;
        padding-bottom: 50px;
        // padding-top: 140px;



        .overseaProduct_item {
            box-sizing: border-box;
            padding: 3px;
            margin: 8px 6px;
            background-color: #fff;
            border-radius: 5px;
            border: 1px solid #fff;


        }

        .overseaProduct_item_active {
            border: 1px solid #F56C6C;

        }

        .update_overseaProduct {

            text-align: right;
            margin: 7px 0;

            .btn {
                background-color: rgb(42, 165, 21);
                border-radius: 3px;
                padding: 4px 5px;
                color: #eee;
                font-size: 12px;
                font-weight: bold;
                cursor: pointer;
            }

            .btn_reverse {
                background-color: #F56C6C;
                border-radius: 3px;
                padding: 4px 5px;
                color: #eee;
                font-size: 12px;
                font-weight: bold;
                cursor: pointer;
            }
        }




        .pic_box {
            width: 173px;
            height: 173px;
            overflow: hidden;
            border-radius: 5px;
            cursor: pointer;
        }

        .title_overseaProduct {
            // width:148px;
            // height: 1.7rem;
            // -webkit-line-clamp: 2;
            // text-overflow: ellipsis;
            // overflow: hidden;
            // font-size: 12px;
            // box-sizing: border-box;
            // padding: 0 0 0 6px;

            font-size: 12px;
            width: 148px;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            white-space: normal !important;
            word-wrap: break-word;
            min-height: 33px;

        }

        .item_desc {
            width: 148px;
            height: 14px;
            overflow: hidden;
            text-overflow: ellipsis;
            font-size: 14px;
            padding: 5px 0 5px 6px;
        }

        .item_desc_parentsku {
            color: #F56C6C;
            width: 148px;
            height: 14px;
            overflow: hidden;
            text-overflow: ellipsis;
            font-size: 14px;
            padding: 5px 0 5px 6px;
            white-space: nowrap;

        }
    }



}

.stepsBox {
    padding: 0px 10px;

    .stepsItem {
        display: flex;
        flex-wrap: wrap;
        position: relative;
        border-left: 1px solid #dcdcdc;

        .stepsIndex {
            position: absolute;
            left: -14px;
            width: 20px;
            height: 20px;
            display: flex;
            justify-content: center;
            align-items: center;
            border-radius: 50%;
            background: #ff8000;
            color: #fff;
            top: -4px;
            border: 4px solid #fff;
        }

        .stepsTitle {
            width: 100%;
            padding-left: 20px;
            font-weight: bold;
            font-size: 16px;
        }

        .stepsContent {
            width: 100%;
            padding: 20px;

            .tips {
                color: red;
            }
        }
    }
}

.recordBox {
    margin-top: 20px;

    .recordTitle {
        width: 100%;
        padding-left: 10px;
        font-weight: bold;
        font-size: 16px;
        border-left: 2px solid #ff8000;
        margin-bottom: 10px;
    }

    .recordItem {
        display: flex;
        justify-content: space-between;
        padding: 10px 20px;
        border-bottom: 1px solid #dcdcdc;
        margin-bottom: 10px;

        .time {
            color: #999;
        }
    }
}
</style>